import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const AboutAPI = createApi({
    reducerPath: "AboutAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            headers.set("Accept", "application/json");
            if (!["addSections", "updateSections"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        addSections: builder.mutation({
            query: ({formData}) => ({
                url: "admin/about/store-about-content",
                method: "POST",
                body: formData,
            }),
        }),
        updateSections: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/about/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
        listAbouContent: builder.query({
            query: () => `about/list-about-content`,
        }),
        getAbouContentById:builder.query({
            query: (id) => `about/show/${id}`,
        }),
    }),
});

export const { useAddSectionsMutation, useUpdateSectionsMutation , useListAbouContentQuery , useGetAbouContentByIdQuery} = AboutAPI;
